import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Modal } from 'antd';
import NoneData from "../common/NoneData";

export class CouponItem extends Component {
  state = {
    visibleModel: false
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentWillMount() {
    let { type } = this.props;
    this.props.actions.fetchMyCouponList({ type });
  }

  openModel(ID) {
    this.props.actions.fetchGetCouponCourseList({ ID });
    this.setState({
      visibleModel: true
    })
  }
  handleCancel() {
    this.setState({
      visibleModel: false
    })
  }

  render() {
    let { visibleModel } = this.state;
    let { fetchMyCouponListSuccess } = this.props.center;
    let { fetchGetCouponCourseListSuccess } = this.props.course;
    let { active } = this.props;
    return (
      <div className="center-coupon-item">
        {fetchMyCouponListSuccess && fetchMyCouponListSuccess.length > 0 ?
          fetchMyCouponListSuccess.map(item => <div className={active ? 'coupon_item' : 'coupon_item active'} key={item.ID}>
            <div className='coupon_item_left'>
              <div style={{ fontSize: 24, marginBottom: 10 }}>
                <span>￥</span><span className='coupon_item_price'>{item.FacePrice}</span>
              </div>
              {active ? <div style={{ fontSize: 12 }}>剩余金额: {item.Surplus}元/{item.UseCount - item.UsedCount}次</div> : <div style={{ fontSize: 12 }}>无可用金额，次数</div>}
            </div>
            <div className='coupon_item_right'>
              <div className='coupon_item_title'>{item.Title}</div>
              {item.RangeType === 0 ?
                <div className='coupon_item_intro'>适用范围：全网通用</div>
                :
                <div className='coupon_item_intro' style={{ cursor: 'pointer' }} onClick={this.openModel.bind(this, item.ID)}>适用范围：部分可用 点击查看>></div>
              }
              <div className='coupon_item_intro'>使用期限：{item.StartTime.split('T')[0] + ' - ' + item.EndTime.split('T')[0]}</div>
              <div className='coupon_item_intro'>使用说明：<span dangerouslySetInnerHTML={{ __html: item.Content || '' }}></span></div>
            </div>
          </div>)
          :
          <div className="noneData">
            <NoneData type={2} />
          </div>
        }
        {fetchGetCouponCourseListSuccess &&
          <Modal
            title="可用范围"
            visible={visibleModel}
            onCancel={this.handleCancel.bind(this)}
            footer={[]}
            bodyStyle={{ color: '#999', lineHeight: 1 }}
          >
            <div className='modal_box'><p style={{ marginBottom: 14 }}><span>券&emsp;&emsp;名：</span>{fetchGetCouponCourseListSuccess.Coupon.Title}</p>
              <p style={{ display: 'flex', flexDirection: 'row', marginBottom: 14 }}><span style={{ width: 70 }}>使用规则：</span><span style={{ flex: 1 }} dangerouslySetInnerHTML={{ __html: fetchGetCouponCourseListSuccess.Coupon.Content }}></span></p>
              <p style={{ marginBottom: 14 }}><span>使用期限：</span>{fetchGetCouponCourseListSuccess.Coupon.StartTime.replace('T', ' ') + ' - ' + fetchGetCouponCourseListSuccess.Coupon.EndTime.replace('T', ' ')}</p>
              <p style={{ marginBottom: 14, lineHeight: '18px', display: 'flex', flexDirection: 'row' }}><span style={{ width: 70 }}>使用范围：</span><span style={{ flex: 1 }}>{fetchGetCouponCourseListSuccess.CourseNameList.join('，')}</span></p></div>
          </Modal>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
    course: state.course
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouponItem);



// WEBPACK FOOTER //
// ./src/features/center/CouponItem.js